export const lang = {
  ing: {
    accept: "Accept",
    accessRestricted: "Your access is restricted",
    accountInative: "The account is inactive",
    activeGroup:
      "Here you can create groups and assign participants. You can also assign territory points to a specific group.",
    activate: "Activate",
    add: "Add",
    addName: "Enter a name",
    addNewAddress: "Add new address",
    addObserv: "Add the observations",
    addresses: "Addresses",
    addSeccion: "Add section",
    all: "All",
    allGroups: "All groups",
    allTerAsk: "Do you want to open all territories?",
    askClean: "Do you want to clear the address markings?",
    askCreateArea: "Do you want to create a new boundary?",
    askDeleteEvent: "",
    askDeleteGroup: "Do you want to delete this group?",
    askDeleteUser: "Do you want to delete this user?",
    askRemovePin: "Do you want to delete the pin from this point?",
    askUpdateArea: "Do you want to update this boundary?",
    cancel: "Cancel",
    change: "Change",
    changeName: "Change Name",
    changeNumber: "Change Number",
    clean: "Clean",
    close: "Close",
    closedStreet: "Closed street",
    closedStreetDetails: "To indicate closed or blocked streets",
    color: "Color",
    colorsList: {
      orange: "Orange",
      blue: "Blue",
      red: "Red",
      gray: "Gray",
      yellow: "Yellow",
      violet: "Violet",
      green: "Green",
      purple: "Purple",
    },
    construction: "Construction",
    constructionDetails: "To indicate construction work on the road",
    country: "Country",
    crash: "Vehicle accident",
    crashDetails: "To indicate vehicle collisions or crashes",
    create: "Create",
    createNew: "Create new",
    criminal: "Criminals",
    criminalDetails: "To indicate criminals or suspicious persons",
    data: "Data",
    date: "Date",
    day: "day",
    days: "days",
    daysName: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    daysNameShort: ["Sun.", "Mon.", "Tues.", "Wed.", "Thurs.", "Fri.", "Sat."],
    default: "Default",
    delete: "Delete",
    deleteActivity: "Do you want to delete this activity?",
    deleteArea: "Do you want to remove this limit?",
    deletePin: "Remove pin",
    delTer: "Do you want to delete this territory?",
    edit: "Edit",
    editGroups: "Edit groups",
    email: "Email",
    end: "End",
    enter: "Enter",
    enterEditor:
      "You are entering as an editor, the changes you make to the territories will not be recorded in the history.",
    enterInfo: "Enter information",
    event: "Event",
    events: "Events",
    exit: "Logout",
    export: "Export",
    exportPDF: "Do you want to export to PDF?",
    finalized: "Finalized",
    fire: "Fire",
    fireDetails: "To indicate fires or the threat of fires",
    flag: "Flag",
    flagDetails: "To indicate a new address point.",
    flood: "Flood",
    floodDetails: "To indicate flooding or overflowing water",
    go: "Go",
    guide: "Guide",
    group: "Group",
    groups: "Groups",
    groupsTerritories: "groups of territories",
    hour: "Hour",
    initCode: "Code",
    initEnter: "Enter",
    initName: "Name",
    initPassword: "Password",
    inProgress: "In progress",
    landslides: "Landslides",
    landslidesDetails: "To indicate a landslide or falling trees",
    lastConnection: "Last Connection",
    legalInfo: "Legal Information",
    loading: "Loading...",
    map: "Map",
    meetingPoint: "Meeting point",
    meetingPointDetails: "To indicate a meeting point",
    members: "Members",
    missingField: "Missing field: ",
    month: "month",
    months: "months",
    monthsFullName: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthsName: [
      "jan.",
      "feb.",
      "mar.",
      "apr.",
      "may.",
      "jun.",
      "jul.",
      "aug.",
      "sep.",
      "oct.",
      "nov.",
      "dic.",
    ],
    mostRecent: "Recent",
    mostOverdue: "Overdue",
    name: "Name",
    nameExists: "Name already exists",
    networkError: "Network error",
    new: "New",
    newAddress: "New address",
    newGroup: "New group",
    newNumber: "New Number",
    newTer: "New Territory",
    noActivities: "No activities",
    noResults: "No results",
    noSpecialAllowed: "Symbols and punctuation are not allowed",
    notes: "Notes",
    number: "Number",
    observations: "Observations",
    ok: "Ok",
    open: "Open",
    openThisPoint: "Do you want to open this point?",
    pin: "Pin",
    placeName: "Place name",
    point: "Point",
    points: "Points",
    privacyCookies: "Privacy and cookies",
    protest: "Protest",
    protestDetails: "To indicate protests or public disturbances",
    readyToStart: "Ready",
    record: "Record",
    records: "Records",
    relocate: "Relocate",
    satellite: "Satellite",
    saidBy: "Said by ",
    save: "Save",
    saving: "Saving...",
    says: " says:",
    scheduled: "Scheduled",
    search: "Search",
    selectGuide: "Select a guide",
    selectTerritory: "Select a territory",
    sort: "Sort by",
    start: "Start",
    status: "Status",
    streets: "Streets",
    terAsk: "Do you want to open this territory?",
    termsOfUse: "Terms of Use",
    territories: "Territories",
    territory: "Territory",
    territoryAlert: "Alert message",
    tileError:
      "Error loading map template. If the error persists, contact the administrator or change the map template.",
    tileNames: {
      default: "Default Settings",
      offline: "Local map",
      OSM: "Roadmap (OSM)",
      Road: "Roadmap (Bing)",
      Aerial: "Satellite (Esri)",
      AerialLabel: "Satellite with labels (Bing)",
      Roadmap: "Roadmap (GM)",
      Terrain: "Terrain",
      Altered_roadmap: "Altered roadmap",
      Satellite_only: "Satelital map",
      Terrain_only: "Terrain only",
      Hybrid: "Hybrid",
    },
    time: "Time",
    title: "Title",
    today: "Today",
    toNumber: "Number",
    update: "Update",
    updateNameMsg: "The name must have {min} to {max} characters",
    users: "Users",
    year: "year",
    years: "years",
    wantClean: "Do you want to clear all annotations?",
    wantDeleteAddress: "Do you want to delete this location?",
    wantDeleteGroup: "Do you want to delete this group?",
    wantExit: "Do you want to log out?",
    wantRoute: "Do you want to open this route?",
    wantUpdate: "Do you want to update the position?",
    whatInsert: "What do you want to add?",
    withoutGroup: "Without group",
    startLogin: "Starting Login...",
    badCredentials: "Incorrect credentials",
    netWorkError: "Connection error",
    updateError: "Update error",
    pleaseSelect: "Please select: ",
    avatar: "avatar",
    conditionsUse: "Conditions of use",
    conditionsLeyend: [],
    version: "Version",
  },
  esp: {
    accept: "Aceptar",
    accessRestricted: "Su acceso está restringido",
    accountInative: "La cuenta está inactiva",
    activeGroup:
      "Aquí podrás crear grupos y asignar a los participantes. También podrás asignar puntos de los territorios a determinado grupo.",
    activate: "Activar",
    add: "Agregar",
    addName: "Ingrese un nombre",
    addNewAddress: "Agregar nueva dirección",
    addObserv: "Agregue las observaciones",
    addresses: "Direcciones",
    addSeccion: "Agregar sección",
    all: "Todos",
    allGroups: "Todos los grupos",
    allTerAsk: "¿Desea abrir todos los territorios?",
    askClean: "¿Desea limpiar las marcaciones de las direcciones?",
    askCreateArea: "¿Desea crear un nuevo límite?",
    askDeleteEvent: "Do you want to delete this event?",
    askDeleteGroup: "¿Desea eliminar este grupo?",
    askDeleteUser: "¿Desea eliminar este usuario?",
    askRemovePin: "¿Desea eliminar el pin de este punto?",
    askUpdateArea: "¿Desea actualizar este límite?",
    cancel: "Cancelar",
    change: "Cambiar",
    changeName: "Cambiar Nombre",
    changeNumber: "Cambiar Número",
    clean: "Limpiar",
    close: "Cerrar",
    closedStreet: "Calle cerrada",
    closedStreetDetails: "Para indicar calle cerradas o bloqueadas",
    color: "Color",
    colorsList: {
      orange: "Naranja",
      blue: "Azul",
      red: "Rojo",
      gray: "Gris",
      yellow: "Amarillo",
      violet: "Violeta",
      green: "Verde",
      purple: "Púrpura",
    },
    construction: "Construcción",
    constructionDetails: "Para indicar trabajos de construcción en la vía",
    country: "País",
    crash: "Accidente vehicular",
    crashDetails: "Para indicar colisiones o choques vehículares",
    create: "Crear",
    createNew: "Crear nuevo",
    criminal: "Delincuentes",
    criminalDetails: "Para indicar delincuentes o personas sospechosas",
    data: "Datos",
    date: "Fecha",
    day: "día",
    days: "días",
    daysName: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    daysNameShort: ["Dom.", "Lun.", "Mar.", "Miérc.", "Juev.", "Vier.", "Sáb."],
    default: "Por defecto",
    delete: "Eliminar",
    deleteActivity: "¿Desea eliminar esta actividad?",
    deletePin: "Quitar pin",
    deleteArea: "¿Desea eliminar este límite?",
    delTer: "¿Desea eliminar este territorio?",
    edit: "Editar",
    editGroups: "Editar grupos",
    email: "Email",
    end: "Fin",
    enter: "Ingresar",
    enterEditor:
      "Usted está entrando como editor, los cambios que haga en los territorios no quedará registrado en el historial.",
    enterInfo: "Ingrese información",
    event: "Evento",
    events: "Eventos",
    exit: "Salir",
    export: "Exportar",
    exportPDF: "¿Desea exportar a PDF?",
    finalized: "Finalizado",
    fire: "Incendio",
    fireDetails: "Para indicar incendios o amenaza de incendios",
    flag: "Bandera",
    flagDetails: "Para indicar nuevo punto de direcciones.",
    flood: "Inundación",
    floodDetails: "Para indicar inundaciones o desbordamientos de agua",
    go: "Ir",
    guide: "Guía",
    group: "Grupo",
    groups: "Grupos",
    groupsTerritories: "Grupos de territorios",
    hour: "Hora",
    initCode: "Código",
    initEnter: "Ingresar",
    initName: "Nombre",
    initPassword: "Contraseña",
    inProgress: "En curso",
    landslides: "Deslizamientos de tierra",
    landslidesDetails:
      "Para indicar deslizamiento de tierra o caída de árboles",
    lastConnection: "Última Conexión",
    legalInfo: "Información Legal",
    loading: "Cargando...",
    map: "Mapa",
    meetingPoint: "Punto de encuentro",
    meetingPointDetails: "Para indicar un punto de reunión",
    members: "Miembros",
    missingField: "Campo incompleto: ",
    month: "mes",
    months: "meses",
    monthsFullName: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthsName: [
      "ene.",
      "feb.",
      "mar.",
      "abr.",
      "may.",
      "jun.",
      "jul.",
      "ago.",
      "sep.",
      "oct.",
      "nov.",
      "dic.",
    ],
    mostRecent: "Recientes",
    mostOverdue: "Atrasados",
    name: "Nombre",
    nameExists: "El nombre ya existe",
    networkError: "Error de red",
    new: "Nuevo",
    newAddress: "Nueva dirección",
    newGroup: "Nuevo grupo",
    newNumber: "Nuevo Número",
    newTer: "Nuevo Territorio",
    noActivities: "Sin actividades",
    noResults: "Sin resultados",
    noSpecialAllowed: "No están permitido símbolos ni puntuaciones",
    notes: "Notas",
    number: "Número",
    pin: "Pin",
    placeName: "Nombre del lugar",
    observations: "Observaciones",
    ok: "Ok",
    open: "Abrir",
    openThisPoint: "¿Desea abrir este punto?",
    point: "Punto",
    points: "Puntos",
    privacyCookies: "Privacidad y cookies",
    protest: "Protesta",
    protestDetails: "Para indicar protestas o disturbios públicos",
    readyToStart: "Preparado",
    record: "Registro",
    records: "Historial",
    relocate: "Reubicar",
    satellite: "Satelital",
    saidBy: "Dicho por ",
    save: "Guardar",
    saving: "Guardando...",
    says: " dice:",
    scheduled: "Agendado",
    search: "Buscar",
    selectGuide: "Escoga un guía",
    selectTerritory: "Seleccione un territorio",
    sort: "Ordenar por",
    start: "Inicio",
    status: "Estado",
    streets: "Calles",
    terAsk: "¿Desea abrir este territorio?",
    termsOfUse: "Condiciones de uso",
    territories: "Territorios",
    territory: "Territorio",
    territoryAlert: "Mensaje de alerta",
    tileError:
      "Error en la carga del modelo de mapa. Si el error persiste consulte al administrador o cambie de modelo de mapa.",
    tileNames: {
      default: "Configuración por defecto",
      offline: "Mapa local",
      OSM: "Calles (OSM)",
      Road: "Calles (Bing)",
      Aerial: "Satelital (Esri)",
      AerialLabel: "Satelital con etiquetas (Bing)",
      Roadmap: "Mapa de calles (GM)",
      Terrain: "Terreno",
      Altered_roadmap: "Mapa de calles alterados",
      Satellite_only: "Mapa satélital",
      Terrain_only: "Sólo terreno",
      Hybrid: "Hibrido",
    },
    time: "Tiempo",
    title: "Título",
    today: "Hoy",
    toNumber: "Numerar",
    update: "Actualizar",
    updateNameMsg: "The name must have {min} to {max} characters",
    users: "Usuarios",
    year: "año",
    years: "años",
    wantClean: "¿Desea limpiar todas las anotaciones?",
    wantDeleteAddress: "¿Desea eliminar este local?",
    wantDeleteGroup: "¿Desea eliminar este grupo?",
    wantExit: "¿Desea salir?",
    wantRoute: "¿Desea marcar esta ruta?",
    wantUpdate: "¿Desea actualizar la posición?",
    whatInsert: "¿Qué desea agregar?",
    withoutGroup: "Sin grupo",
    startLogin: "Entrando...",
    badCredentials: "Credenciales incorrectas",
    netWorkError: "Error de conexión",
    updateError: "Error al actualizar",
    pleaseSelect: "Por favor seleccione: ",
    avatar: "avatar",
    conditionsUse: "Condiciones de uso",
    conditionsLeyend: [
      "",
      "",
      "¡Bienvenido a MapaCHE!",
      "Estos términos y condiciones describen las reglas y regulaciones para el uso de la app MapaCHE.",
      "Al utilizar esta aplicación, asumimos que aceptas estos términos y condiciones. No continúes usando MapaCHE si no estás de acuerdo con todos los términos y condiciones establecidos en esta página.",
      "",
      "<b>Cookies:</b>",
      "El sitio web utiliza cookies para ayudar a personalizar tu experiencia en línea. Al acceder a MapaCHE, aceptaste utilizar las cookies necesarias.",
      "Una cookie es un archivo de texto que un servidor de páginas web coloca en tu disco duro. Las cookies no se pueden utilizar para ejecutar programas o enviar virus a tu computadora. Las cookies se te asignan de forma exclusiva y solo un servidor web en el dominio que emitió la cookie puede leerlas.",
      "Podemos utilizar cookies para recopilar, almacenar y rastrear información con fines estadísticos o de marketing para operar nuestro sitio web. Tienes la capacidad de aceptar o rechazar cookies opcionales. Hay algunas cookies obligatorias que son necesarias para el funcionamiento de nuestro sitio web. Estas cookies no requieren tu consentimiento ya que siempre funcionan. Ten en cuenta que al aceptar las cookies requeridas, también aceptas las cookies de terceros, que podrían usarse a través de servicios proporcionados por terceros si utilizas dichos servicios en nuestro sitio web, por ejemplo, una ventana de visualización de video proporcionada por terceros e integrada en nuestro sitio web.",
      "",
      "Licencia:",
      "A menos que se indique lo contrario, MapaCHE y/o sus licenciantes poseen los derechos de propiedad intelectual de todo el material en MapaCHE. Todos los derechos de propiedad intelectual son reservados. Puedes acceder desde MapaCHE para tu uso personal sujeto a las restricciones establecidas en estos términos y condiciones.",
      "",
      "No debes:",
      "Copiar o volver a publicar material de MapaCHE",
      "Vender, alquilar o sublicenciar material de MapaCHE",
      "Reproducir, duplicar o copiar material de MapaCHE",
      "Redistribuir contenido de MapaCHE",
      "Este acuerdo comenzará el fecha presente.",
      "Partes de este sitio web ofrecen a los usuarios la oportunidad de publicar e intercambiar opiniones e información en determinadas áreas. MapaCHE no filtra, edita, publica ni revisa los comentarios antes de su presencia en el sitio web. Los comentarios no reflejan los puntos de vista ni las opiniones de MapaCHE, sus agentes y/o afiliados. Los comentarios reflejan los puntos de vista y opiniones de la persona que publica. En la medida en que lo permitan las leyes aplicables, MapaCHE no será responsable de los comentarios ni de ninguna responsabilidad, daños o gastos causados ​​o sufridos como resultado de cualquier uso o publicación o apariencia de comentarios en este sitio web.",
      "MapaCHE se reserva el derecho de monitorear todos los comentarios y eliminar los que puedan considerarse inapropiados, ofensivos o que incumplan estos Términos y Condiciones.",
      "",
      "Garantizas y declaras que:",
      "Tienes derecho a publicar comentarios en nuestro sitio web y tienes todas las licencias y consentimientos necesarios para hacerlo;",
      "Los comentarios no invaden ningún derecho de propiedad intelectual, incluidos, entre otros, los derechos de autor, patentes o marcas comerciales de terceros;",
      "Los comentarios no contienen ningún material difamatorio, calumnioso, ofensivo, indecente o ilegal de otro modo, que sea una invasión de la privacidad.",
      "Los comentarios no se utilizarán para solicitar o promover negocios o actividades comerciales personalizadas o presentes o actividades ilegales.",
      "Por la presente, otorgas a MapaCHE una licencia no exclusiva para usar, reproducir, editar y autorizar a otros a usar, reproducir y editar cualquiera de tus comentarios en todas y cada una de las formas, formatos, o medios.",
      "",
      "Hipervínculos a nuestro contenido:",
      "Las siguientes organizaciones pueden vincularse a nuestro sitio web sin aprobación previa por escrito:",
      "Agencias gubernamentales;",
      "Motores de búsqueda;",
      "Organizaciones de noticias;",
      "Los distribuidores de directorios en línea pueden vincularse a nuestro sitio web de la misma manera que hacen hipervínculos a los sitios web de otras empresas que figuran en la lista; y Empresas acreditadas en todo el sistema, excepto que soliciten organizaciones sin fines de lucro, centros comerciales de caridad y grupos de recaudación de fondos de caridad que no pueden hacer hipervínculos a nuestro sitio web.",
      "Estas organizaciones pueden enlazar a nuestra página de inicio, a publicaciones o a otra información del sitio siempre que el enlace: (a) no sea engañoso de ninguna manera; (b) no implique falsamente patrocinio, respaldo o aprobación de la parte vinculante y sus productos y/o servicios; y (c) encaja en el contexto del sitio de la parte vinculante.",
      "Podemos considerar y aprobar otras solicitudes de enlaces de los siguientes tipos de organizaciones:",
      "fuentes de información de consumidores y/o empresas comúnmente conocidas;",
      "sitios de la comunidad .com;",
      "asociaciones u otros grupos que representan organizaciones benéficas;",
      "distribuidores de directorios en línea;",
      "portales de Internet;",
      "firmas de contabilidad, derecho y consultoría; y instituciones educativas y asociaciones comerciales.",
      "Aprobaremos las solicitudes de enlace de estas organizaciones si: (a) el enlace no nos haría vernos desfavorablemente a nosotros mismos ni a nuestras empresas acreditadas; (b) la organización no tiene registros negativos con nosotros; (c) el beneficio para nosotros de la visibilidad del hipervínculo compensa la ausencia de MapaCHE; y (d) el enlace está en el contexto de información general de recursos.",
      "Estas organizaciones pueden enlazar a nuestra página de inicio siempre que el enlace: (a) no sea engañoso de ninguna manera; (b) no implique falsamente patrocinio, respaldo o aprobación de la parte vinculante y sus productos o servicios; y (c) encaja en el contexto del sitio de la parte vinculante.",
      "Si eres una de las organizaciones enumeradas en el párrafo 2 y estás interesada en vincularte a nuestro sitio web, debes informarnos enviando un correo electrónico a MapaCHE. Incluye tu nombre, el nombre de tu organización, la información de contacto, así como la URL de tu sitio, una lista de las URL desde las que tienes la intención de vincular a nuestro sitio web y una lista de las URL de nuestro sitio a las que te gustaría acceder. Espera 2-3 semanas para recibir una respuesta.",
      "Las organizaciones aprobadas pueden hacer hipervínculos a nuestro sitio web de la siguiente manera:",
      "Mediante el uso de nuestro nombre corporativo; o",
      "Mediante el uso del localizador uniforme de recursos al que se está vinclando; o",
      "Usar cualquier otra descripción de nuestro sitio web al que está vinculado que tenga sentido dentro del contexto y formato del contenido en el sitio de la parte vinculante.",
      "No se permitirá el uso del logotipo de MapaCHE u otro material gráfico para vincular sin un acuerdo de licencia de marca comercial.",
      "Responsabilidad del contenido:",
      "No seremos responsables de ningún contenido que aparezca en tu sitio web. Aceptas protegernos y defendernos contra todas las reclamaciones que se presenten en tu sitio web. Ningún enlace(s) debe aparecer en ningún sitio web que pueda interpretarse como difamatorio, obsceno o criminal, o que infrinja, de otra manera viole o defienda la infracción u otra violación de los derechos de terceros.",
      "Reserva de derechos:",
      "Nos reservamos el derecho de solicitar que elimines todos los enlaces o cualquier enlace en particular a nuestro sitio web. Apruebas eliminar de inmediato todos los enlaces a nuestro sitio web cuando se solicite. También nos reservamos el derecho de modificar estos términos y condiciones y su política de enlaces en cualquier momento. Al vincular continuamente a nuestro sitio web, aceptas estar vinculado y seguir estos términos y condiciones de vinculación.",
      "Eliminación de enlaces de nuestro sitio web:",
      "Si encuentras algún enlace en nuestro sitio que sea ofensivo por cualquier motivo, puedes contactarnos e informarnos en cualquier momento. Consideraremos las solicitudes para eliminar enlaces, pero no estamos obligados a hacerlo ni a responder directamente.",
      "No nos aseguramos de que la información de este sitio web sea correcta. No garantizamos su integridad o precisión, ni prometemos asegurarnos de que el sitio web permanezca disponible o que el material en el sitio se mantenga actualizado.",
      "",
      "Exención de responsabilidad:",
      "En la medida máxima permitida por la ley aplicable, excluimos todas las representaciones, garantías y condiciones relacionadas con nuestro sitio web y el uso de este. Nada en este descargo de responsabilidad:",
      "limitará o excluirá nuestra responsabilidad o la tuya por muerte o lesiones personales;",
      "limitará o excluirá nuestra responsabilidad o la tuya por fraude o tergiversación fraudulenta;",
      "limitará cualquiera de nuestras responsabilidades o las tuyas de cualquier manera que no esté permitida por la ley aplicable; o",
      "excluirá cualquiera de nuestras responsabilidades o las tuyas que no puedan estar excluidas según la ley aplicable.",
      "Las limitaciones y prohibiciones de responsabilidad establecidas en esta sección y en otras partes de este descargo de responsabilidad: (a) están sujetas al párrafo anterior; y (b) regirá todas las responsabilidades que surjan en virtud de la exención de responsabilidad, incluidas las responsabilidades que surjan en el contrato, en agravio y por incumplimiento de la obligación legal.",
      "Siempre que el sitio web y la información y los servicios en el sitio se proporcionen de forma gratuita, no seremos responsables de ninguna pérdida o daño de cualquier naturaleza.",
    ],
    version: "Versión",
  },
  ch: {
    accept: "接受",
    accessRestricted: "您的訪問受到限製",
    accountInative: "帳戶不活躍",
    activeGroup:
      "您可以在這裏創建群組並分配參與者。您還可以為特定群組分配領地積分。",
    activate: "打開",
    add: "添加",
    addName: "輸入名稱",
    addNewAddress: "添加新地址",
    addObserv: "寫下觀察筆記",
    addresses: "地址",
    addSeccion: "添加部分",
    all: "全部",
    allGroups: "所有組",
    allTerAsk: "你想開放所有地區嗎？",
    askClean: "您想清除地址標記嗎？",
    askCreateArea: "您想建立新的極限嗎？",
    askDeleteEvent: "您想刪除此事件嗎？",
    askDeleteGroup: "您要刪除該群組嗎？",
    askDeleteUser: "您想刪除該用戶嗎？",
    askRemovePin: "您想從此處刪除圖釘嗎？",
    askUpdateArea: "您想更新此邊界嗎？",
    cancel: "取消",
    change: "改變",
    changeName: "更換名字",
    changeNumber: "更改號碼",
    clean: "清理列表",
    close: "關閉",
    closedStreet: "道路封閉",
    closedStreetDetails: "指示封閉或道路封鎖",
    color: "顏色",
    colorsList: {
      orange: "橘色",
      blue: "藍色",
      red: "紅色",
      gray: "灰色",
      yellow: "黃色",
      violet: "紫色",
      green: "綠色",
      purple: "紫色",
    },
    construction: "建造",
    constructionDetails: "指示道路上正在施工",
    country: "國家",
    crash: "車輛事故",
    crashDetails: "指示車輛碰撞或撞車",
    create: "創建",
    createNew: "創建新的",
    criminal: "罪犯",
    criminalDetails: "指示罪犯或可疑人員",
    data: "資料",
    date: "日期",
    day: "天",
    days: "天",
    daysName: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
    daysNameShort: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
    default: "預設",
    delete: "刪除",
    deleteActivity: "您想刪除這個活動嗎？",
    deletePin: "刪除地圖釘",
    deleteArea: "您想刪除這個定界嗎？",
    delTer: "您想刪除這個地區嗎？",
    edit: "編輯",
    editGroups: "編輯群組",
    email: "電子郵件",
    end: "結束",
    enter: "進入",
    enterEditor: "您以編輯者身份進入，您對領土所做的更改不會記錄在歷史中。",
    enterInfo: "輸入信息",
    event: "事件",
    events: "事件",
    exit: "註銷",
    export: "匯出",
    exportPDF: "您想匯出為 PDF 文件嗎？",
    finalized: "已完成",
    fire: "火災",
    fireDetails: "表示火災或火災威脅",
    flag: "標誌",
    flagDetails: "指示新的地址點。",
    flood: "洪水",
    floodDetails: "表示洪水或水溢出",
    go: "去",
    guide: "嚮導",
    group: "組",
    groups: "組",
    groupsTerritories: "地區群",
    hour: "時間",
    initCode: "號碼",
    initEnter: "登入",
    initName: "名字",
    initPassword: "密碼",
    inProgress: "進行中",
    landslides: "山崩",
    landslidesDetails: "表示山崩或樹木倒塌",
    lastConnection: "最後連接",
    legalInfo: "法律信息",
    loading: "加載中。。。",
    map: "地圖",
    meetingPoint: "集合點",
    meetingPointDetails: "指示會面地點",
    members: "成員",
    missingField: "缺失字段: ",
    month: "個月",
    months: "個月",
    monthsFullName: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
    monthsName: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
    mostRecent: "最近",
    mostOverdue: "最逾期",
    name: "名字",
    nameExists: "名字已存在",
    networkError: "網路錯誤",
    new: "新",
    newAddress: "新地址",
    newGroup: "新組",
    newNumber: "新號碼",
    newTer: "新地圖",
    noActivities: "沒有活動",
    noResults: "沒有結果",
    noSpecialAllowed: "不允許使用符號和標點符號",
    notes: "記錄",
    number: "數字",
    pin: "別針",
    placeName: "地名",
    observations: "觀察",
    ok: "好的",
    open: "打開",
    openThisPoint: "你想打開這個點嗎？",
    point: "點",
    points: "點",
    privacyCookies: "隱私和Cookie",
    protest: "抗議",
    protestDetails: "表示抗議或公眾騷亂",
    readyToStart: "準備開始",
    record: "記錄",
    records: "記錄",
    relocate: "搬遷",
    satellite: "衛星視圖",
    saidBy: "說這話的人是",
    save: "保存",
    saving: "正在保存。。。",
    says: "說：",
    scheduled: "預定的",
    search: "搜索",
    selectGuide: "選擇嚮導",
    selectTerritory: "選擇一個地區",
    sort: "排序方式",
    start: "開始",
    status: "狀態",
    streets: "街道視圖",
    terAsk: "你想開放這個地區嗎？",
    termsOfUse: "使用條款",
    territories: "地區",
    territory: "地區",
    territoryAlert: "地區的警報訊息",
    tileError:
      "載入地圖模型時發生錯誤。如果錯誤仍然存在，請諮詢管理員或更改地圖模型。",
    tileNames: {
      default: "預設設定",
      offline: "離線地圖",
      OSM: "路線圖 (OSM)",
      Road: "路線圖 (Bing)",
      Aerial: "衛星地圖 (Esri)",
      AerialLabel: "衛星地圖和名字 (Bing)",
      Roadmap: "路線圖 (GM)",
      Terrain: "地形",
      Altered_roadmap: "改變路線圖",
      Satellite_only: "衛星地圖",
      Terrain_only: "只有地形",
      Hybrid: "混合地圖",
    },
    time: "時間",
    title: "標題",
    today: "今天",
    toNumber: "數字",
    update: "更新",
    updateNameMsg: "名稱必須包含 {min} 至 {max} 個字符",
    users: "用戶",
    year: "年",
    years: "年",
    wantClean: "您想清除所有註釋嗎？",
    wantDeleteAddress: "你想刪除這個地址嗎？",
    wantDeleteGroup: "您要刪除該群組嗎？",
    wantExit: "你想退出嗎？",
    wantRoute: "您想開通這條航線嗎？",
    wantUpdate: "您想更新這個點的位置嗎？",
    whatInsert: "你想添加什么？",
    withoutGroup: "無組",
    startLogin: "開始登入。。。",
    badCredentials: "憑證不正確",
    netWorkError: "連線錯誤",
    updateError: "更新錯誤",
    pleaseSelect: "請選擇：",
    avatar: "頭像",
    conditionsUse: "使用條件",
    conditionsLeyend: [],
    version: "版本",
  },
  chs: {
    accept: "接受",
    accessRestricted: "您的访问受到限制",
    accountInative: "帐户不活跃",
    activeGroup:
      "您可以在这里创建群组并分配参与者。您还可以为特定群组分配领地积分。",
    activate: "打开",
    add: "添加",
    addName: "输入名称",
    addNewAddress: "添加新地址",
    addObserv: "写下观察笔记",
    addresses: "地址",
    addSeccion: "添加部分",
    all: "全部",
    allGroups: "所有组",
    allTerAsk: "你想开放所有地区吗？",
    askClean: "您想清除地址标记吗？",
    askCreateArea: "您想创建新的极限吗？",
    askDeleteEvent: "您想删除此事件吗？",
    askDeleteGroup: "您要删除该群组吗？",
    askDeleteUser: "您要删除该用户吗？",
    askRemovePin: "您想从此处删除图钉吗？",
    askUpdateArea: "您想更新此边界吗？",
    cancel: "取消",
    change: "改变",
    changeName: "更换名字",
    changeNumber: "更改号码",
    clean: "清理列表",
    close: "关闭",
    closedStreet: "道路封闭",
    closedStreetDetails: "指示封闭或道路封锁",
    color: "颜色",
    colorsList: {
      orange: "橙色",
      blue: "蓝色",
      red: "红色",
      gray: "灰色",
      yellow: "黄色",
      violet: "紫色",
      green: "绿色",
      purple: "紫色",
    },
    construction: "建造",
    constructionDetails: "指示道路上正在施工",
    country: "国家",
    crash: "车辆事故",
    crashDetails: "指示车辆碰撞或撞车",
    create: "创建",
    createNew: "创建新的",
    criminal: "罪犯",
    criminalDetails: "指示罪犯或可疑人员",
    data: "资料",
    date: "日期",
    day: "天",
    days: "天",
    daysName: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    daysNameShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    default: "预设",
    delete: "删除",
    deleteActivity: "您想删除这个活动吗？",
    deletePin: "删除地图钉",
    deleteArea: "您想删除这个定界吗？",
    delTer: "您想删除这个地区吗？",
    edit: "编辑",
    editGroups: "编辑群组",
    email: "电子邮件",
    end: "结束",
    enter: "进入",
    enterEditor: "您以编辑者身份进入，您对领土所做的更改不会记录在历史中。",
    enterInfo: "输入信息",
    event: "事件",
    events: "事件",
    exit: "注销",
    export: "汇出",
    exportPDF: "您想汇出为 PDF 文件吗？",
    finalized: "已完成",
    fire: "火灾",
    fireDetails: "表示火灾或火灾威胁",
    flag: "标志",
    flagDetails: "指示新的地址点。",
    flood: "洪水",
    floodDetails: "表示洪水或水溢出",
    go: "去",
    guide: "向导",
    group: "组",
    groups: "组",
    groupsTerritories: "地区群",
    hour: "时间",
    initCode: "号码",
    initEnter: "登入",
    initName: "名字",
    initPassword: "密码",
    inProgress: "进行中",
    landslides: "山崩",
    landslidesDetails: "表示山崩或树木倒塌",
    lastConnection: "最后连接",
    legalInfo: "法律信息",
    loading: "加载中。。。",
    month: "个月",
    map: "地图",
    meetingPoint: "集合点",
    meetingPointDetails: "指示会面地点",
    members: "成员",
    missingField: "缺失字段: ",
    months: "个月",
    monthsFullName: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
    monthsName: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
    mostRecent: "最近",
    mostOverdue: "最逾期",
    name: "名字",
    nameExists: "名字已存在",
    networkError: "网路错误",
    new: "新",
    newAddress: "新地址",
    newGroup: "新组",
    newNumber: "新号码",
    newTer: "新地图",
    noActivities: "没有活动",
    noResults: "没有结果",
    noSpecialAllowed: "不允许使用符号和标点符号",
    notes: "记录",
    number: "数字",
    pin: "別针",
    placeName: "地名",
    observations: "观察",
    ok: "好的",
    open: "打开",
    openThisPoint: "你想打开这个点吗？",
    point: "点",
    points: "点",
    privacyCookies: "隐私和Cookie",
    protest: "抗议",
    protestDetails: "表示抗议或公众骚乱",
    readyToStart: "准备开始",
    record: "记录",
    records: "记录",
    relocate: "搬迁",
    satellite: "卫星视图",
    saidBy: "说这话的人是伊莱亚斯",
    save: "保存",
    saving: "正在保存。。。",
    says: "说：",
    scheduled: "预定的",
    search: "搜索",
    selectGuide: "选择向导",
    selectTerritory: "选择一个地区",
    sort: "排序方式",
    start: "开始",
    status: "状态",
    streets: "街道视图",
    terAsk: "你想开放这个地区吗？",
    termsOfUse: "使用条款",
    territories: "地区",
    territory: "地区",
    territoryAlert: "地区的警报讯息",
    tileError:
      "载入地图模型时发生错误。如果错误仍然存在，请谘询管理员或更改地图模型。",
    tileNames: {
      default: "预设设定",
      offline: "离线地图",
      OSM: "路线图 (OSM)",
      Road: "路线图 (Bing)",
      Aerial: "卫星地图 (Esri)",
      AerialLabel: "卫星地图和名字 (Bing)",
      Roadmap: "路线图 (GM)",
      Terrain: "地形",
      Altered_roadmap: "改变路线图",
      Satellite_only: "卫星地图",
      Terrain_only: "只有地形",
      Hybrid: "混合地图",
    },
    time: "时间",
    title: "标题",
    today: "今天",
    toNumber: "数字",
    update: "更新",
    updateNameMsg: "名称必须包含 {min} 至 {max} 个字符",
    users: "用户",
    year: "年",
    years: "年",
    wantClean: "您想清除所有注释吗？",
    wantDeleteAddress: "你想删除这个地址吗？",
    wantDeleteGroup: "您要删除该群组吗？",
    wantExit: "你想退出吗？",
    wantRoute: "您想开通这条航线吗？",
    wantUpdate: "您想更新这个点的位置吗？",
    whatInsert: "你想添加什么？",
    withoutGroup: "无组",
    startLogin: "开始登入。。。",
    badCredentials: "凭证不正确",
    netWorkError: "连线错误",
    updateError: "更新错误",
    pleaseSelect: "请选择：",
    avatar: "头像",
    conditionsUse: "使用条件",
    conditionsLeyend: [],
    version: "版本",
  },
};
